import React from "react"
import PropTypes from "prop-types"
import { connect } from "react-redux"

import GetMoreView from "./get_more_view/index"
import SearchView from "./search_view/index"
import SearchInput from "./../shared/search_input"
import debounce from "lodash/debounce"

import { toggleView, setOrigin } from "./reducers/view_toggle"
import { fetchSearchResults, setSearchTerm } from "./reducers/search_results"

import logIFTTTNextAction from "app/lib/ifttt_next_log_action"

class GetMoreLandingPage extends React.Component {
  constructor(props) {
    super(props)

    this.state = { historyAction: "pushState" }

    if (this.props.searchTerm.length) {
      this.props.toggleView("search")
    }

    this.executeSearch = debounce(this.executeSearch, 250)
  }

  executeSearch = term => {
    //whenever new search results are loaded we are treating it as a new page view.
    logIFTTTNextAction("page_viewed", {
      location_type: "search",
      object_id: term,
      object_type: "applet_service_merged",
    })

    this.props.getSearchResults(term)
  }

  prettifyTerm = term => {
    return term.trim().replace(/\./g, "")
  }

  onQuerySearch = evt => {
    //Not trimming this here because we want the user to be able to put spaces in the search bar.
    const term = evt.target.value

    // Reset search and back to discover page
    if (term === "") {
      this.onXClick()
      return
    }

    //On the Search page we want the url bar to change to match the query and active tab.
    const url = `/search/query/${term}`
    window.history[this.state.historyAction]({ turbolinks: true, url }, "", url)

    this.setState({ historyAction: "replaceState" })

    if (this.props.currentView !== "search") {
      this.props.toggleView("search")
      this.props.setOrigin("discover")
    }

    const previousTerm = this.props.searchTerm

    //show non-prettified term in the search bar
    this.props.setSearchTerm(term)

    //prettify term and compare to previous term for the actual search query
    const termForSearch = this.prettifyTerm(term)

    if (termForSearch === this.prettifyTerm(previousTerm)) {
      return
    }

    this.executeSearch(termForSearch)
  }

  onClick = () => {
    const object_type =
      this.props.currentView === "discover" ? "discover_field" : "search_field"

    logIFTTTNextAction("click", {
      location_type: this.props.currentView,
      object_type,
    })
  }

  onXClick = () => {
    this.props.setSearchTerm("")

    //Show discover view and set the origin to search
    this.props.toggleView("discover")
    this.props.setOrigin("search")

    logIFTTTNextAction("click", {
      location_type: "search",
      object_type: "search_close",
    })

    //Change the url bar back to the Get More/Explore page. TODO: Change this to Discover
    window.history.pushState({}, "", "/explore")
  }

  render() {
    return (
      <div className="get-more-container">
        <div className={`${this.props.currentView} get-more-header`}>
          <h1>Explore</h1>
          <div className={`${this.props.currentView} ifttt-next-search`}>
            <SearchInput
              autoComplete="off"
              autoFocus={true}
              maxLength="1024"
              onChange={this.onQuerySearch}
              onClick={this.onClick}
              onXClick={this.onXClick}
              placeholder="Search"
              showCloseIcon={this.props.currentView === "search"}
              value={this.props.searchTerm}
            />
          </div>
        </div>
        {this.props.currentView === "search" ? <SearchView /> : <GetMoreView />}
      </div>
    )
  }
}

const mapStateToProps = state => {
  return {
    currentView: state.viewToggle.currentView,
    searchTerm: state.searchResults.searchTerm,
  }
}

const mapDispatchToProps = dispatch => {
  return {
    toggleView: view => dispatch(toggleView(view)),
    setOrigin: view => dispatch(setOrigin(view)),
    getSearchResults: term => dispatch(fetchSearchResults(term)),
    setSearchTerm: term => dispatch(setSearchTerm(term)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(GetMoreLandingPage)

GetMoreLandingPage.propTypes = {
  currentView: PropTypes.string,
  toggleView: PropTypes.func,
  setOrigin: PropTypes.func,
  getSearchResults: PropTypes.func,
  setSearchTerm: PropTypes.func,
  searchTerm: PropTypes.string.isRequired,
  diyPath: PropTypes.string,
}

GetMoreLandingPage.defaultProps = {
  searchTerm: "",
}
